import Vue
  from 'vue';
import Vuex
  from 'vuex';
import VuexORM
  from '@vuex-orm/core';
import VuexORMAxios
  from '@vuex-orm/plugin-axios';
// import createPersistedState from 'vuex-persistedstate'; // save SST
// import createMutationsSharer from 'vuex-shared-mutations'; // sync mutations
import main
  from './modules/main';
import globalSearch from './modules/globalSearch'
import reporting from './modules/reporting'
import notifications from './modules/notifications'
import trialUtils from './modules/trialUtils'
import database
  from '../orm/database';
import { baseHttpOptions } from '../utils/api';

const isProduction = process.env.NODE_ENV === 'production';

Vue.use(Vuex);

VuexORM.use(VuexORMAxios, {
  database,
  http: {
    ...baseHttpOptions,
    onResponse(response) {
      return response.data || {};
    },
    async onError(error) {
      switch (error.response.status) {
        case 401:
          this.onUnauthorised(error);
          break;
        case 404:
          this.onNotFound(error);
          break;
        case 422:
          this.onValidationError(error);
          break;
        case 500:
          this.onServerError(error);
          break;
        default:
          this.onGenericError(error);
          break;
      }

      return Promise.reject(error);
    },
  },
});

export function createStore() {
  const options = {
    strict: true, ...main,
    plugins: [VuexORM.install(database)],
    modules: {
      globalSearch,
      reporting,
      notifications,
      trialUtils
    }
  };
  if (isProduction) {
    options.plugins = [...options.plugins, // createPersistedState(),
      // createMutationsSharer({ predicate: [] }),
    ];
  }
  return new Vuex.Store(options);
}
